export default "__VITE_ASSET__81517899__"